import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useMenu } from '../../hooks/useMenu';
import { APPLICANT_TYPES } from '../../util/constants';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import { HeadingSubtitle } from '../../components/Heading';
import BusinessNameForm from '../../components/Forms/BusinessNameForm';
import themeColors from '../../assets/styles/themeColors';

const VerifyBusinessName = () => {
  const { t } = useTranslation();
  const { activeMenu, activeItem } = useMenu();
  const formId = 'verifyBusiness_form';
  const [eventType, setEventType] = useState(null);

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeItem={activeItem}
      previousPath={activeItem?.previousPath}
      formId={formId}
      setEventType={setEventType}
    >
      <HeadingSubtitle mb={32} color={themeColors.colorTextSecondary}>
        {t('verifyBusinessName.title')}
      </HeadingSubtitle>
      <BusinessNameForm
        applicantType={APPLICANT_TYPES.BUSINESS}
        nextPath={activeItem?.nextPath}
        formId={formId}
        setEventType={setEventType}
        eventType={eventType}
      />
    </OnBoardingContainer>
  );
};

export default VerifyBusinessName;
